import { createActions, handleActions, Action } from "redux-actions";
import { Services } from "~api/services";

interface CodigoPostal {
  label: string;
  value: string;
}

interface FetchCodigosPostalesCompletedPayload {
  response: string[];
}

interface CodigoPostalSelectorState {
  codigosPostales: CodigoPostal[];
  isLoading: boolean;
}

const {
  business: {
    codigosPostales: {
      clearCodigosPostales,
      fetchCodigosPostalesInited,
      fetchCodigosPostalesCompleted,
      fetchCodigosPostalesFailed,
    },
  },
} = createActions({
  business: {
    codigosPostales: {
      clearCodigosPostales: () => ({}),
      fetchCodigosPostalesInited: () => ({}),
      fetchCodigosPostalesCompleted: (response: string[]) => ({ response }),
      fetchCodigosPostalesFailed: (error: any) => ({ error }),
    },
  },
});

const fetchCodigosPostales = (provinciaId: string, localidad: string) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(fetchCodigosPostalesInited());
      const response = await services.api
        .provincias()
        .getCodigosPostales(provinciaId, localidad);
      dispatch(fetchCodigosPostalesCompleted(response.codigosPostales));
    } catch (error) {
      console.error(error);
      dispatch(fetchCodigosPostalesFailed(error));
    }
  };
};

const initialState: CodigoPostalSelectorState = {
  codigosPostales: [],
  isLoading: false,
};

const codigoPostalSelectorReducer = handleActions<
  CodigoPostalSelectorState,
  any
>(
  {
    [clearCodigosPostales.toString()]: (): CodigoPostalSelectorState => ({
      ...initialState,
    }),
    [fetchCodigosPostalesInited.toString()]: (): CodigoPostalSelectorState => ({
      ...initialState,
      isLoading: true,
    }),
    [fetchCodigosPostalesCompleted.toString()]: (
      _state: CodigoPostalSelectorState,
      action: Action<FetchCodigosPostalesCompletedPayload>
    ): CodigoPostalSelectorState => {
      const codigosPostales = action.payload.response.map((item) => ({
        value: item,
        label: item,
      }));
      return {
        ...initialState,
        codigosPostales,
        isLoading: false,
      };
    },
    [fetchCodigosPostalesFailed.toString()]: (): CodigoPostalSelectorState => ({
      ...initialState,
      isLoading: false,
    }),
  },
  initialState
);

export default codigoPostalSelectorReducer;
export {
  clearCodigosPostales,
  fetchCodigosPostalesInited,
  fetchCodigosPostalesCompleted,
  fetchCodigosPostalesFailed,
  fetchCodigosPostales,
};
